import { NgModule } from '@angular/core';
import { NkThemeOptionsComponent } from './theme-options.component';

@NgModule({
  imports: [
    NkThemeOptionsComponent
  ],
  exports: [NkThemeOptionsComponent]
})
export class NkThemeOptionsModule {}